// frontend/src/billing/SubscriptionExpiredPopup.js
// UrbanQ v1.9.9.6 - Popup de Suscripcion Expirada para Admins
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getPlansArray } from '../config/planConfig';

const SubscriptionExpiredPopup = ({ user, onLogout }) => {
    const navigate = useNavigate();
    const plans = getPlansArray();
    const currentUser = user || JSON.parse(localStorage.getItem('user') || '{}');

    const handleSelectPlan = (plan) => {
        navigate('/billing/checkout', {
            state: {
                plan: {
                    ...plan,
                    isTrial: false,
                    finalPrice: plan.price
                },
                userId: currentUser.id,
                condominiumId: currentUser.condominium_id,
                isRenewal: true
            }
        });
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (onLogout) onLogout();
        navigate('/login');
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'linear-gradient(135deg, #0a0a1a 0%, #1a0a2e 50%, #0a0a1a 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999,
            overflow: 'auto',
            padding: '20px'
        }}>
            {/* Background pattern */}
            <div style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: 'radial-gradient(rgba(217, 70, 239, 0.08) 1px, transparent 1px)',
                backgroundSize: '30px 30px',
                pointerEvents: 'none'
            }} />

            <div style={{
                position: 'relative',
                background: 'rgba(17, 17, 24, 0.95)',
                border: '1px solid rgba(217, 70, 239, 0.2)',
                borderRadius: '24px',
                padding: '40px',
                maxWidth: '860px',
                width: '100%',
                boxShadow: '0 0 40px rgba(217, 70, 239, 0.15), 0 25px 50px rgba(0,0,0,0.5)',
                animation: 'fadeSlideUp 0.5s ease'
            }}>
                {/* Warning Icon */}
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '80px',
                        height: '80px',
                        fontSize: '40px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, rgba(239, 68, 68, 0.2) 0%, transparent 70%)',
                        border: '2px solid rgba(239, 68, 68, 0.3)',
                        marginBottom: '16px'
                    }}>
                        &#9888;
                    </div>
                    <h1 style={{
                        fontSize: '26px',
                        fontWeight: 700,
                        color: '#fafafa',
                        margin: '0 0 8px'
                    }}>
                        Tu suscripcion ha expirado
                    </h1>
                    <p style={{
                        fontSize: '15px',
                        color: '#a1a1aa',
                        margin: 0
                    }}>
                        {currentUser.name ? `${currentUser.name}, tu` : 'Tu'} acceso al sistema esta suspendido.
                        Selecciona un plan para reactivar tu cuenta.
                    </p>
                </div>

                {/* Data safety notice */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    background: 'rgba(34, 197, 94, 0.08)',
                    border: '1px solid rgba(34, 197, 94, 0.2)',
                    borderRadius: '12px',
                    padding: '14px 18px',
                    marginBottom: '28px'
                }}>
                    <span style={{ fontSize: '24px' }}>&#128274;</span>
                    <p style={{ margin: 0, fontSize: '13px', color: '#a1a1aa' }}>
                        <strong style={{ color: '#22c55e' }}>Tus datos estan seguros.</strong> Toda la informacion
                        de tu condominio esta preservada. Al renovar recuperaras acceso inmediato.
                    </p>
                </div>

                {/* Plan Cards */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '16px',
                    marginBottom: '24px'
                }}>
                    {plans.map(plan => (
                        <div
                            key={plan.id}
                            onClick={() => handleSelectPlan(plan)}
                            style={{
                                background: 'rgba(255,255,255,0.03)',
                                border: plan.recommended ? '2px solid #764ba2' : '1px solid rgba(255,255,255,0.08)',
                                borderRadius: '16px',
                                padding: '24px 20px',
                                cursor: 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.25s ease',
                                position: 'relative'
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = `0 8px 30px rgba(${plan.recommended ? '118, 75, 162' : '255,255,255'}, 0.15)`;
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            {plan.badge && (
                                <span style={{
                                    position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)',
                                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                    color: '#fff', fontSize: '11px', fontWeight: 700,
                                    padding: '4px 14px', borderRadius: '12px', whiteSpace: 'nowrap'
                                }}>
                                    {plan.badge}
                                </span>
                            )}

                            <div style={{ fontSize: '16px', fontWeight: 600, color: '#e2e8f0', marginBottom: '8px' }}>
                                {plan.name}
                            </div>
                            <div style={{ fontSize: '32px', fontWeight: 700, color: plan.color, marginBottom: '4px' }}>
                                ${plan.price}
                            </div>
                            <div style={{ fontSize: '13px', color: '#718096', marginBottom: '16px' }}>
                                {plan.duration} {plan.savings ? ` | ${plan.savings}` : ''}
                            </div>

                            <div style={{
                                fontSize: '12px', color: '#a0aec0',
                                textAlign: 'left', lineHeight: '1.8'
                            }}>
                                {plan.features.slice(0, 5).map((f, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                        <span style={{ color: plan.color, flexShrink: 0 }}>&#10003;</span>
                                        <span>{f}</span>
                                    </div>
                                ))}
                                {plan.features.length > 5 && (
                                    <div style={{ color: plan.color, fontWeight: 600, marginTop: '6px', textAlign: 'center' }}>
                                        +{plan.features.length - 5} mas...
                                    </div>
                                )}
                            </div>

                            <button style={{
                                width: '100%',
                                marginTop: '16px',
                                padding: '10px',
                                border: 'none',
                                borderRadius: '10px',
                                background: plan.recommended
                                    ? 'linear-gradient(135deg, #667eea, #764ba2)'
                                    : 'rgba(255,255,255,0.08)',
                                color: '#fff',
                                fontSize: '13px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}>
                                Seleccionar Plan
                            </button>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: '12px', color: '#718096', margin: '0 0 16px' }}>
                        Pago seguro mediante PayPal. Al seleccionar un plan seras redirigido al checkout.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
                        <a
                            href="mailto:soporte@nextunicodecorp.com"
                            style={{ fontSize: '13px', color: '#a1a1aa', textDecoration: 'none' }}
                        >
                            &#128231; soporte@nextunicodecorp.com
                        </a>
                        <button
                            onClick={handleLogout}
                            style={{
                                background: 'transparent',
                                border: '1px solid rgba(255,255,255,0.1)',
                                borderRadius: '8px',
                                color: '#a1a1aa',
                                padding: '6px 16px',
                                fontSize: '13px',
                                cursor: 'pointer'
                            }}
                        >
                            Cerrar Sesion
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes fadeSlideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @media (max-width: 768px) {
                    div[style*="gridTemplateColumns: repeat(3"] {
                        grid-template-columns: 1fr !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default SubscriptionExpiredPopup;
